export default __webpack_public_path__ + "static/media/cam.4c5e4bd5.svg";